/** Mask an API key, showing only the first 4 and last 4 characters.
 *  @param key     the secret to mask
 *  @param empty   label to return when the key is falsy (defaults to an
 *                 em-dash, matching the original ForwarderPage behaviour). */
export function maskKey(key, empty = '\u2014') {
    if (!key) return empty;
    if (key.length <= 8) return '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022';
    return key.slice(0, 4) + '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' + key.slice(-4);
}
